import { put, take } from "typed-redux-saga";
import workerChannel from "./worker.channel";
import { workerActions } from "../../reducers/worker.slice";

type TWorkerResult = { key: string; dCor: number };

export function* dCOrWorkerXSaga() {
  const webWorker = new Worker(
    new URL("../workers/dcor.worker.js", import.meta.url)
  );
  const channel = workerChannel(webWorker);

  while (true) {
    try {
      const action = yield* take(workerActions.calculateDCorX);
      webWorker.postMessage({ X: action.payload.X, Y: action.payload.Y });
      const data = (yield* take(channel)) as TWorkerResult;

      yield* put(
        workerActions.setDCor({
          key: action.payload.key,
          coordinate: "x",
          dCor: data.dCor as number,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}

export function* dCorWorkerYSaga() {
  const webWorker = new Worker(
    new URL("../workers/dcor.worker.js", import.meta.url)
  );
  const channel = workerChannel(webWorker);

  while (true) {
    try {
      const action = yield* take(workerActions.calculateDCorY);
      webWorker.postMessage({ X: action.payload.X, Y: action.payload.Y });
      const data = (yield* take(channel)) as TWorkerResult;

      yield* put(
        workerActions.setDCor({
          key: action.payload.key,
          coordinate: "y",
          dCor: data.dCor,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}

export function* dCorWorkerZSaga() {
  const webWorker = new Worker(
    new URL("../workers/dcor.worker.js", import.meta.url)
  );
  const channel = workerChannel(webWorker);

  while (true) {
    try {
      const action = yield* take(workerActions.calculateDCorZ);
      webWorker.postMessage({ X: action.payload.X, Y: action.payload.Y });
      const data = (yield* take(channel)) as TWorkerResult;

      yield* put(
        workerActions.setDCor({
          key: action.payload.key,
          coordinate: "z",
          dCor: data.dCor,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}
